import * as React from "react";
import type { AppPreviewGalleryFlyoutAnchorProps } from "./AppPreviewGalleryFlyoutAnchor.types";
// eslint-disable-next-line no-restricted-imports
import { renderAppFlyoutAnchor } from "@1js/acui-button/lib/Next";
import { useAppPreviewGalleryFlyoutAnchor } from "./useAppPreviewGalleryFlyoutAnchor";
import { useAppPreviewGalleryFlyoutAnchorStyles } from "./useAppPreviewGalleryFlyoutAnchorStyles.styles";

export const AppPreviewGalleryFlyoutAnchor = React.memo(
  React.forwardRef<HTMLButtonElement, AppPreviewGalleryFlyoutAnchorProps>(
    (props, ref) => {
      const state = useAppPreviewGalleryFlyoutAnchor(props, ref);

      useAppPreviewGalleryFlyoutAnchorStyles(state);

      return renderAppFlyoutAnchor(state, props);
    }
  )
);

AppPreviewGalleryFlyoutAnchor.displayName =
  "next/AppPreviewGalleryFlyoutAnchor";

export type AppPreviewGalleryFlyoutAnchor =
  typeof AppPreviewGalleryFlyoutAnchor.prototype;
